import CommonHeader from '../pages/Head'
import React from 'react'
import axios from 'axios';
import UpdateBank from '../pages/updateBank'

class HomtContents extends React.Component {	  
	constructor(props) {
		super(props);
		this.state = {CompName:'',isUpdating:false,	viewProfile:true, checkid:'',LID:localStorage.getItem('tokens'),profileinfo:[]};		
		this.handleClick=this.handleClick.bind(this);		
		this.handleProfile=this.handleProfile.bind(this);
	}
	componentDidMount() {	
		const para={LID:this.state.LID}
		axios.post(process.env.REACT_APP_API_ENV+'api/userinformation.php',para)
			.then(result => {						
				this.setState({profileinfo:result.data})				
					{/*this.setState({checkid:result.data[52].substring(8,12)})	*/}
			})							
		axios.post(process.env.REACT_APP_API_ENV+'api/FindCompanyName.php')
			.then(result => {				
				this.setState({CompName:result.data[0]})													
			})		
	}
	handleClick(){				
		this.setState(prevState=>({isUpdating: !prevState.isUpdating}))		
		this.setState(prevState=>({viewProfile: !prevState.viewProfile}))		
	}	
	handleProfile(){				
		this.setState(prevState=>({viewProfile: !prevState.viewProfile}))			
		this.setState({isUpdating:false})		
	}
	render() {		
		return(
			<div id="content">
				<CommonHeader titles="Bank"/>
				<h2 style={{textAlign:'center'}}>{this.state.CompName + ' welcome ' + this.state.profileinfo[1]}</h2><br/>
				<div style={{textAlign:'center'}}>
				<button onClick={this.handleProfile}>{this.state.viewProfile ? "View Bank Information Now":"View Bank Information?"}</button>&nbsp;&nbsp;
				<button onClick={this.handleClick}>{this.state.isUpdating ? "Updating  Bank Information Now": "Update Your Bank Information?"}</button><br/><br/>
				</div>
				{(()=>{if(this.state.viewProfile === true) {return (<div>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Bank Name:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[12]}</label>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>FIN Number:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[14]}</label><br/>					
					
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Transit Number:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[13]}</label>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Checking Account:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[15]}</label><br/>
					
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Debit Card Number:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[17]}</label>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Online Password:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[18]}</label><br/>
					
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Security Question 1:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[22]}</label>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Question 1 Answer:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[23]}</label><br/>
					
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Security Question 2:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[24]}</label>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Question 2 Answer:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[25]}</label><br/>
					
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Security Question 3:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[26]}</label>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Question 3 Answer:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[27]}</label><br/>
					
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Security Question 4:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[28]}</label>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Question 4 Answer:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[29]}</label><br/>
					
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Security Question 5:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[30]}</label>
					<label style={{width: '180px',display:'inline-block',textAlign:'right'}}><b>Question 5 Answer:</b></label>
					<label style={{width: '150px',display:'inline-block',textAlign:'left',marginLeft:'5px'}}>{this.state.profileinfo[31]}</label><br/><br/>
					<label>Please update your banking information if anything changed, thanks for your cooperation!</label><br/><br/>	
						
				</div>)}})()}	
				{(()=>{if(this.state.isUpdating === true) {return (
					<UpdateBank/>
				)}})()}			
			</div>
		)
	}
}

export default HomtContents